














import { Component, Vue, Prop } from "vue-property-decorator";
import { AccessLogEntryModel } from "../models";
import moment from "moment";

@Component
export default class AccessLogTable extends Vue {
  @Prop({ required: true })
  value!: AccessLogEntryModel[];

  get headers(): { text: string; value: string }[] {
    return [
      {
        text: this.$t("invoices.table.invoiceID").toString(),
        value: "invoice_id",
      },
      {
        text: this.$t("invoices.table.createdAt").toString(),
        value: "created_at",
      },
    ];
  }

  pagination = {
    descending: true,
    sortBy: "created_at",
  };

  prettyDate(d: Date): string {
    return d.toString() == `0001-01-01T00:00:00Z`
      ? this.$t("invoices.terms.never").toString()
      : moment(d).format("DD-MM-YYYY HH:mm");
  }
}
